<template>
  <div>
    <div style="margin-bottom: 20px">
      <el-button type="danger" @click="createdItem">新 增</el-button>
    </div>
    <el-table
        :data="tableData" class="table" height="570px"
        row-key="id" border v-loading="tableLoading">
      <el-table-column prop="name" label="名称" width="240"/>
      <el-table-column label="请假单位">
        <template #default="scope">
          {{dict.applyUnit[scope.row.minLeaveUnit].name}}
        </template>
      </el-table-column>
      <el-table-column label="请假条件">
        <template #default="scope">
          {{dict.holidayCondition[scope.row.newStaffLeave].name}}
        </template>
      </el-table-column>
      <el-table-column label="是否带薪">
        <template #default="scope">
          {{dict.isPaid[scope.row.paidLeave].name}}
        </template>
      </el-table-column>
      <el-table-column prop="addTime" label="创建时间"/>
      <el-table-column label="操作" width="110" align="center">
        <template #default="scope">
          <div style="margin-right: 4px;">
            <el-button type="text" size="small" style="margin-right: 10px" @click.prevent="updateItem(scope.row)">编辑</el-button>
            <el-popconfirm title="确定要删除吗？" @confirm="deleteItem(scope.row.id)">
              <el-button slot="reference" type="text" size="small" style="color: red;">删除</el-button>
            </el-popconfirm>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
        style="text-align: right;margin: 20px 10px"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="tableQuery.pageSize"
        @current-change="changePage"
        layout="total, prev, pager, next, jumper"
        :total="tableTotal">
    </el-pagination>
    <created-holiday-rule @refresh="selectHolidayRulePage" ref="created"/>
    <update-holiday-rule @refresh="selectHolidayRulePage" ref="update"/>
  </div>
</template>

<script>
import {selectHolidayRulePage,deleteHolidayRule} from '/src/api/attendance/holiday'
import CreatedHolidayRule from "./CreatedHolidayRule";
import UpdateHolidayRule from "./UpdateHolidayRule";
export default {
  name: "HolidayRule",
  components:{CreatedHolidayRule,UpdateHolidayRule},
  data() {
    return {
      tableQuery:{
        name:"",
        pageIndex:0,
        pageSize:9,
      },
      tableTotal:0,
      tableData:[],
      roleGroup:[],
      tableLoading:false,


      dict:{
        isPaid:[{id:0,name:"带薪"},{id:1,name:"不带薪"}],
        applyUnit:[{id:0,name:"按天申请"},{id:1,name:"按半天申请"}],
        holidayCondition:[{id:1,name:"转正可申请"},{id:0,name:"入职可申请"},{id:2,name:"入职半年可申请"}],
        holidayRemaining:[{id:0,name:"不限余额"},{id:1,name:"限制余额"}],
        calculationType:[{id:0,name:"按自然日计算请假时长"},{id:1,name:"按工作日计算请假时长"}],
        holidayRemainingGrantType:[{id:0,name:"手动发放"}],
        holidayRemainingValidityDate:[{id:0,name:"入职起12个月"},{id:1,name:"自然年 1月1日~12月30日"}],
        holidayRemainingRetain:[{id:0,name:"直接失效"},{id:1,name:"保留1个月"},
          {id:2,name:"保留2个月"},{id:3,name:"保留3个月"},{id:4,name:"保留4个月"},
          {id:6,name:"保留5个月"},{id:6,name:"保留6个月"},{id:7,name:"保留7个月"},
          {id:8,name:"保留8个月"},{id:9,name:"保留9个月"},{id:10,name:"保留10个月"},
          {id:11,name:"保留11个月"},{id:12,name:"保留12个月"},{id:13,name:"保留13个月"},
          {id:14,name:"保留14个月"},{id:15,name:"保留15个月"},{id:16,name:"保留16个月"},
          {id:17,name:"保留17个月"},{id:18,name:"保留18个月"},{id:19,name:"保留19个月"},
          {id:20,name:"保留20个月"},{id:21,name:"保留21个月"},{id:22,name:"保留22个月"}]
      }
    }
  },
  methods:{
    selectHolidayRulePage(){
      this.tableLoading = true;
      selectHolidayRulePage(this.tableQuery).then(val => {
        this.tableLoading = false;
        if (val.status==200){
          this.tableData = val.data.list;
          this.tableTotal = val.data.total;
        }
      })
    },
    changePage(index){
      this.tableQuery.pageIndex = index;
      this.selectHolidayRulePage();
    },
    createdItem(){
      this.$refs.created.openDialog(this.dict);
    },
    updateItem(item){
      this.$refs.update.openDialog(this.dict,item);
    },
    deleteItem(id){
      deleteHolidayRule(id).then(val => {
        if (val.status == 200){
          this.selectHolidayRulePage();
          this.$message({message: '删除成功！', type: 'success'});
        }
      })
    }
  },
  created() {
    this.selectHolidayRulePage();
  }
}
</script>

<style scoped>
.table{
  width: 100%;
  border-radius: 10px;
  padding: 6px 0px 10px 6px;
}
</style>